module.exports = __webpack_public_path__ + "static/media/poweredByStripe.aed2afcd.svg";